// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","footer__Container":"Footer_footer__Container__Nrif6","footer__CopyRights":"Footer_footer__CopyRights__eQBSm"};